import ProgressBar from '@ramonak/react-progress-bar';
import { rem } from '@triumph/design-system';
import { useAppContext } from '@/app/components/providers/AppContextProvider';
import { Container } from './ProgressBar.StyledComponents';
import { ProgressBarProps } from './ProgressBar.types';

const ProgressBarComponent: React.FC<ProgressBarProps> = ({
    count = 0,
    maxCount = 100,
}) => {
    const { theme } = useAppContext();

    return (
        <Container>
            <ProgressBar
                completed={count}
                maxCompleted={maxCount}
                bgColor={theme.colors.semantic.warningDefault}
                baseBgColor={theme.colors.greyscale.gray15}
                height={rem(8)}
                borderRadius={rem(20)}
                isLabelVisible={false}
                transitionTimingFunction="ease-in"
            />
        </Container>
    );
};

export default ProgressBarComponent;
